import * as React from "react";
import { ContainerFW } from "../../global";
import { Img } from "../../Img";
export const FooterBanner = (props) => (React.createElement(ContainerFW, null,
    React.createElement("div", { className: "footer-banner" },
        React.createElement(Img, { src: props.imageUrl, alt: props.imageAlt }))));
